var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/faqs", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.faq
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createFaq.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.faqSections.length
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.faqHeaderId,
                                  expression: "rules.faqHeaderId"
                                }
                              ],
                              attrs: {
                                label: "Select Section Header",
                                "data-vv-name": "Section Header",
                                "cus-name": "Section Header",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.faqSections,
                                selectedKey: "faqHeaderId",
                                showLabel: "faqHeader"
                              },
                              model: {
                                value: _vm.faq.faqHeaderId,
                                callback: function($$v) {
                                  _vm.$set(_vm.faq, "faqHeaderId", $$v)
                                },
                                expression: "faq.faqHeaderId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.faqImageUrl,
                              expression: "rules.faqImageUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Image URL",
                            placeholder: "Enter Image URL",
                            "data-vv-name": "imageUrl",
                            "cus-name": "imageUrl",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.faq.faqImageUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.faq, "faqImageUrl", $$v)
                            },
                            expression: "faq.faqImageUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.faqVideoUrl,
                              expression: "rules.faqVideoUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Video Code",
                            placeholder: "Enter Video Code",
                            "data-vv-name": "Video Code",
                            "cus-name": "Video Code",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.faq.faqVideoUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.faq, "faqVideoUrl", $$v)
                            },
                            expression: "faq.faqVideoUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.question,
                              expression: "rules.question"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Question",
                            placeholder: "Enter Question",
                            "data-vv-name": "Question",
                            "cus-name": "Question",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.faq.question,
                            callback: function($$v) {
                              _vm.$set(_vm.faq, "question", $$v)
                            },
                            expression: "faq.question"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.response,
                              expression: "rules.response"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Answer",
                            placeholder: "Enter Answer",
                            "data-vv-name": "Answer",
                            "cus-name": "Answer",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.faq.response,
                            callback: function($$v) {
                              _vm.$set(_vm.faq, "response", $$v)
                            },
                            expression: "faq.response"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Create FAQ\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Add FAQ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-207e7898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-207e7898","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Faqs/CreateFaq.vue
// module id = Ln3f
// module chunks = 0